import { useToast } from "@chakra-ui/react";
import { useCallback } from "react";
import { ScrollRestoration, useNavigate, useParams } from "react-router-dom";
import BasePage from "../common/BasePage";
import { useTranslation } from "react-i18next";
import QuestionForm from "../../components/forms/QuestionForm";

type Params = {
  quizId: string;
};

export default function NewQuestionPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const { quizId } = useParams<Params>();
  const onSuccess = useCallback(
    (createdLessonId: number) => {
      navigate(`../${createdLessonId}`);
      toast({
        title: t("new_question_page.new_question"),
        description: t("new_question_page.question_created"),
        status: "success",
        isClosable: true,
      });
    },
    [navigate, t, toast],
  );

  const onError = useCallback(() => {
    toast({
      title: t("new_question_page.question_error"),
      description: t("new_question_page.question_error_message"),
      status: "error",
      isClosable: true,
    });
  }, [t, toast]);

  return (
    <BasePage title={t("new_question_page.new_question")}>
      <ScrollRestoration />
      <QuestionForm quizId={quizId} onSuccess={onSuccess} onError={onError} />
    </BasePage>
  );
}
